import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "HandOver" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import {getListData} from '@/service/main/system'
import dayjs from "dayjs";
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HandOver',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return {title: item.name, value: item.id}
  })
}
getCompanyList()

const getUsedBy = async () => {
  let userList = await getListData('/main/enterpriseWechat/dingUser/listAll', {});
  const userOptions = userList.map((item: any) => {
    return {title: item.userName, value: item.userName};
  })
  const fromUserItem = searchFormConfig.formItems.find(item => item.field === 'fromUserName');
  fromUserItem!.options = userOptions;

  const toUserItem = searchFormConfig.formItems.find(item => item.field === 'toUserName');
  toUserItem!.options = userOptions;
}
getUsedBy()

let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    toUserName: store.state.login.userInfo.realName,
    finishTime: [
      dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD'),
      dayjs().endOf('date').format('YYYY-MM-DD')
    ]
  }
} else {
  queryParam.value = {
    finishTime: [
      dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD'),
      dayjs().endOf('date').format('YYYY-MM-DD')
    ]
  }
}


const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

store.commit('system/changeQueyryInfo', queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] =
  usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "handOver",
      onSortChange: handleSortChange
    }, null, 8, ["contentTableConfig"])
  ]))
}
}

})